import { render, staticRenderFns } from "./SetLang.vue?vue&type=template&id=2eb427e0&scoped=true&"
import script from "./SetLang.vue?vue&type=script&lang=js&"
export * from "./SetLang.vue?vue&type=script&lang=js&"
import style0 from "./SetLang.vue?vue&type=style&index=0&id=2eb427e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb427e0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/SvgIcon.vue').default})
